import React from 'react';
import { Input, Form, Select, Radio, Carousel, Modal } from "antd";
import { PAYTYPE_OF_ONLINE_ALIPAY, PAYTYPE_OF_ODP, mapCode2LinkOfQQDigitalCoin, INVOICE_METHODCODE_OF_CTC, DDPAY_METHODCODE } from '$ACTIONS/constantsData';
import { formatAmount, mul, deteleObject } from '$ACTIONS/util';
import { sendPiwikEventAtUrl } from '$ACTIONS/PiwikUtil';
import { get } from '$ACTIONS/TlcRequest';
import { depositMoneyDecimal, depositMoneyInt } from '$ACTIONS/reg';
import { ApiPort, APISETS } from '$ACTIONS/TLCAPI';
import { GetPayDetail, GetAvailableMethods } from '$DATA/wallet';
import WalletName from '@/RealyName/WalletName';
import WalletName2 from '@/RealyName/WalletName2';
const { Item } = Form;

const ODPPayTypeCode = 'ODP';
const isMoneyInSuggestionAmount = (money, arySuggest) => Array.isArray(arySuggest) && arySuggest.map(v=>v+'').includes(money+'');

const isAllowOptionPayType = (aryOptional, payType) => (aryOptional||[]).includes(payType)
const isStillShowSuggestAmount = (aryStillShowSuggest, payType) => (aryStillShowSuggest||[]).includes(payType)

const DEFAULT_SUGGESTEDAMOUNT_VALUE = '';

class MoneyInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			Channeldefault: '',
			SuggestedAmount: DEFAULT_SUGGESTEDAMOUNT_VALUE,
			Amountvalue: '',
			SuggestedAmounthide: false,
			// ^^^^^^^^^^^^^ it looks that SuggestedAmounthide is useless
			Amountfalse: false,
			isSetAmountFromSuggested: false,
			isTutorial: false,
			carouselPage: 0
		};
		this.findName = this.findName.bind(this);
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
		this.carousel = React.createRef();
		this.uniqueAmountStatus = true;
		this.ispayMethod = '';
		props.payMethodList.some((v) => {
			if (v.code === props.payTypeCode) {
				this.ispayMethod = v;
				this.uniqueAmountStatus = v.uniqueAmountStatus;
				return true;
			}
		});
		/* 只有这些需要有支付渠道 */
		this.Needlist = [ 'JDP', 'OA', 'UP', 'QQ', 'BC', 'BCM', 'WC', 'PPB', ODPPayTypeCode ];
		this.allowOptionalForNeedlist = [ ODPPayTypeCode ];
		this.stillShowSuggestAmountForNeedlist = [ ODPPayTypeCode ];
		this.inputTimer = false;
		const mapCode2LinkKeys = Object.keys(mapCode2LinkOfQQDigitalCoin)
		this.isQQEBpay = props.payMethodList.some(item =>
			item.code === "QQ" && item.availableMethods.some(method => mapCode2LinkKeys.indexOf(method.methodCode.toLowerCase())!==-1));
	}

	componentDidMount() {
		this.setState({
			Channeldefault: this.ispayMethod != '' ? GetAvailableMethods(this.ispayMethod) : ''
		});
	}

	componentWillUnmount() {
		this.setState({ isSetAmountFromSuggested: false });
	}

	onChange = (e, conf={}) => {
		let targetValue = conf.isFromAntdSelect ? e : e.target.value
		this.setState({
			Channeldefault: targetValue,
			SuggestedAmounthide: true,
			SuggestedAmount: ''
		});
		this.props.setFieldsValue({
			money: ''
		});

		this.props.setLoading(true);
		GetPayDetail(
			this.props.payTypeCode,
			(data) => {
				this.props.setCurrDepositDetail(data.result);
				this.props.setLoading(false);
			},
			targetValue
		);
	};

	Testamount = (value, payTypeCode) => {
		this.setState({ isSetAmountFromSuggested: false });
		if (!value) {
			return;
		}

		// 添加防抖节流
		// if (this.inputTimer) {
		//     return;
		// }

		//this.inputTimer = true;
		clearTimeout(this.inputTimer);
		this.props.setLoading(true);
		this.inputTimer = setTimeout(() => {
			let val = value.toString().replace(/^-/, ''); // Don't need to care/check the first -
			let isFloat = /^\d+\.\d+$/.test(val);
			let isInt = /^\d+$/.test(val);
			if (!isFloat && !isInt) { // CXPC-5 UAT 1st: avoid display red message
				this.props.setLoading(false);
				return;
			}
			get(`
                ${ApiPort.SuggestedAmount}?amount=${value}&method=${payTypeCode}&methodcode=${this.state
					.Channeldefault} ${APISETS}`).then((res) => {
						//this.inputTimer = false;
						this.props.setLoading(false);
						const IS_CXPC712_CXPC734 = [ODPPayTypeCode, 'PPB'].includes(payTypeCode) && res?.result?.length === 0;
						if (IS_CXPC712_CXPC734) {
							// no length then need to hide
							this.setState({
								SuggestedAmount: DEFAULT_SUGGESTEDAMOUNT_VALUE
							});
							return;
						}
						if (res && res.isSuccess && res.result.length != 0) {
							this.setState(
								{
									SuggestedAmount: res.result,
									SuggestedAmounthide: false
								},
								// () => {
								//     let error = this.props.getFieldError("money");
								//     let haveData = false;
								//     res.result.map((item) => {
								//         if (item == value) {
								//             this.props.setFieldsValue({
								//                 money: value,
								//             });
								//             haveData = true;
								//         }
								//     });
								//     if (!haveData) {
								//         this.props.setFields({
								//             money: {
								//                 value: value,
								//                 errors: [
								//                     new Error(
								//                         error
								//                             ? error != "Error"
								//                                 ? error
								//                                 : ""
								//                             : "请选择以上存款金额以便快速到账"
								//                     ),
								//                 ],
								//             },
								//         });
								//     }
								// }
								() => {
									if (isAllowOptionPayType(this.allowOptionalForNeedlist, payTypeCode)) {
										/* do nothing for optional payTypeCode,
										do not force assign errors on money Field while this.state.SuggestedAmount was assigned array. */
										return;
									}
									let error = this.props.getFieldError('money');
									this.props.setFields({
										money: {
											value: value,
									errors: [ new Error(error ? (error != 'Error' ? error : '') : '') ]
										}
									});
								}
							);
						}
					});
		}, 300);
	};

	findName() {
		return deteleObject(this.ispayMethod.availableMethods);
	}

	handleCancel = () => {
		this.setState({ isTutorial: false });
	};

	previous = () => {
		this.carousel.prev();
	}

	next = () => {
		this.carousel.next();
	}

	generalOnChange = (page) => {
		this.setState({ carouselPage: page });
	};

	render() {
		const { getFieldDecorator, payTypeCode, setFieldsValue, getFieldValue } = this.props;
		let setting = this.props.setting; // 当前支付方式的详情
		!setting && (setting = { MinBal: 0, MaxBal: 0, DayBal: 0 }); // 初始化Setting
		const minBal = formatAmount(setting.minBal),
			transferNumber = formatAmount(setting.transferNumber),
			maxBal = formatAmount(setting.maxBal);
		console.log('Amountvalue', this.state.Amountvalue);
		console.log('getFieldValue', getFieldValue('money'));
		const charges = parseFloat(getFieldValue('money')) + parseFloat(setting.charges * getFieldValue('money'));

		// 0: {MethodType: "极速虚拟币支付", MethodCode: "CHANNEL"}
		// MethodCode: "CHANNEL"
		// MethodType: "极速虚拟币支付"
		// 1: {MethodType: "虚拟币交易所(OTC)", MethodCode: "OTC"}
		// MethodCode: "OTC"
		// MethodType: "虚拟币交易所(OTC)"
		// 2: {MethodType: "虚拟币支付 1", MethodCode: "INVOICE"}
		// MethodCode: "INVOICE"
		// MethodType: "虚拟币支付 1"
		// 3: {MethodType: "虚拟币支付 2", MethodCode: "INVOICE_AUT"}
		// MethodCode: "INVOICE_AUT"
		// MethodType: "虚拟币支付 2"
		const hasMaxMoney = payTypeCode !== 'CTC';
		const IS_PAYTYPECODE_QQ = payTypeCode === 'QQ';
		const IS_ONLY1_AVAILABLE_METHODS = this.ispayMethod?.availableMethods?.length === 1;
		return (
			<React.Fragment>
				{this.Needlist.includes(payTypeCode) &&
					this.ispayMethod != '' &&
					this.ispayMethod.availableMethods.length != 0 && (
						<div>
							{this.ispayMethod.availableMethods.length == 1 &&
								this.ispayMethod.availableMethods[0].methodCode == 'DEFAULT' ? (
								''
							) : (
								<>
									{IS_PAYTYPECODE_QQ ?
										<>
											<a
												className="deposit-help-link"
												onClick={() => {
													sendPiwikEventAtUrl('deposit_digital_coin',
														'DigitalCoin Deposit Page',
														'Deposit',
														'View Tutorial',
														'Deposit_DigitalCoin_C_Tutorial');
													this.setState({ isTutorial: true });
												}}
											>
												查看存款教程
											</a>
											<Modal
												footer={null}
												maskClosable={true}
												onCancel={this.handleCancel}
												visible={this.state.isTutorial}
												width={960}
												title="代币钱包存款教程"
												centered={true}
												className="tutorial-modal"
											>
												<div style={{ display: "flex", flexDirection: "column", paddingTop: "24px", paddingBottom: '24px' }}>
													{this.state.carouselPage !== 0 &&
														<div
															style={{ position: "absolute", zIndex: "10", top: "270px" }}
															onClick={() => {
																this.previous();
															}}
														>
															<img
																className="arrowLeftRight"
																src={"/cn/img/depositlesson/icon-left.svg"}
																alt="left"
															/>
														</div>
													}

													<Carousel
														className="tutorial-carousel"
														key={"EBPAY"}
														infinite={false}
														ref={node => (this.carousel = node)}
														afterChange={(current) => {
															this.generalOnChange(current);
														}}
													>
														<img src="/cn/img/tutorial/EBPAY_desktop-tutorial_1.jpg" alt="EBPAY_desktop-tutorial_1.jpg" />
														<img src="/cn/img/tutorial/EBPAY_desktop-tutorial_2.jpg" alt="EBPAY_desktop-tutorial_2.jpg" />
														<img src="/cn/img/tutorial/EBPAY_desktop-tutorial_3.jpg" alt="EBPAY_desktop-tutorial_3.jpg" />
														<img src="/cn/img/tutorial/EBPAY_desktop-tutorial_4.jpg" alt="EBPAY_desktop-tutorial_4.jpg" />

													</Carousel>
													{this.state.carouselPage !== 3 &&
														<div
															style={{ position: "absolute", zIndex: "10", top: "270px", right: "24px" }}
															onClick={() => {
																this.next();
															}}
														>
															<img
																className="arrowLeftRight"
																src={"/cn/img/depositlesson/icon-right.svg"}
																alt="right"
															/>
														</div>
													}
												</div>
											</Modal>
										</>
										: null}
									<Item
										label={
											<div>
												{IS_PAYTYPECODE_QQ ? '选择代币钱包' : '支付渠道'}
												{/* <span className="theme-color">
													{" "}
													*
												</span> */}
											</div>
										}
										className={`Pay_Radio ${payTypeCode}`}
									>
										{IS_PAYTYPECODE_QQ ?
											<Select
												disabled={IS_PAYTYPECODE_QQ && IS_ONLY1_AVAILABLE_METHODS}
												defaultValue={IS_ONLY1_AVAILABLE_METHODS ? this.ispayMethod?.availableMethods?.[0].methodCode : undefined}
												placeholder={'请选择代币钱包'}
												className={`setBon${this.isQQEBpay ? ' alike-digital-coin-select' : ''}`}
									            onChange={code => this.onChange(code, {isFromAntdSelect: true})}>
												{this.ispayMethod.availableMethods.map(m => {
													return (<Option value={m.methodCode}>
											<div style={{textAlign:'left'}}>
												<img src={"/cn/img/DIGITALCOIN/" + m.methodCode + ".svg"} alt="" style={{float:'left',width:32,height:32}} />
												<span style={{display:'inline-block',width:6}} />
															{m.methodType}
														</div>
											</Option>)})
												}
											</Select>
											:
											<Radio.Group onChange={(e) => this.onChange(e)} value={this.state.Channeldefault}>
												{deteleObject(this.ispayMethod.availableMethods).map((item, index) => {
													return (
														item.methodCode != 'DEFAULT' && (
															<Radio
																key={item.methodCode + index}
																className={item.methodCode}
																value={item.methodCode}
															>
																{item.methodType}
															</Radio>
														)
													);
												})}
											</Radio.Group>
										}
									</Item>
								</>
							)}
						</div>
					)}
				{this.state.Channeldefault == 'C2C' ? (
					<div className="modal-prompt-info error-color">
						使用{
							deteleObject(this.ispayMethod.availableMethods).find(
								(item) => item.methodCode == this.state.Channeldefault
							).methodType
						}{' '}
						进行存款，请务必上传存款凭证以完成交易。
					</div>
				) : null}
				{this.state.Channeldefault == DDPAY_METHODCODE ? (
					<div className="modal-prompt-info error-color">
						使用{
							this.findName().find(
								(item) => item.methodCode == this.state.Channeldefault
							).methodType
						}{' '}
						存款，务必在 15 分钟内完成转账并上传凭证以确保交易成功。
					</div>
				) : null}
				{payTypeCode == 'WC' && setting.charges && setting.charges < 0 ? (
					<div className="TextLightYellow">
						温馨提示：使用{this.ispayMethod.name}
						进行存款时，第三方平台将征收手续费 {mul(Math.abs(setting.charges), 100)} %
					</div>
				) : null}

				{[PAYTYPE_OF_ONLINE_ALIPAY, PAYTYPE_OF_ODP].includes(payTypeCode) ? 
				<WalletName2
					payTypeCode={payTypeCode}
					getFieldDecorator={getFieldDecorator}
					antForm={this.props.antForm}
					showDepositorNameField={setting && setting.showDepositorNameField}
					prefillRegisteredName={setting && setting.prefillRegisteredName}
					isc2c={this.state.Channeldefault == 'C2C'}
				/> :
				<WalletName
					payTypeCode={payTypeCode}
					getFieldDecorator={getFieldDecorator}
					showDepositorNameField={setting && setting.showDepositorNameField}
					prefillRegisteredName={setting && setting.prefillRegisteredName}
					isc2c={this.state.Channeldefault == 'C2C'}
				/>}

				<Item
					label={
						<div>
							{`存款金额`} {/* ${`（￥${minBal}~￥${maxBal}）`} */}
							{/* <span className="theme-color">*</span> */}
						</div>
					}
					className="deposit-moneyinput"
				>
					{getFieldDecorator('money', {
						initialValue: this.props.money || '',
						getValueFromEvent: (event) => {
							// 限制只能为数字并且数字最多带2位小数
							const reg = /^(\.*)(\d+)(\.?)(\d{0,2}).*$/g;
							let payTypeCode4Switch = payTypeCode;
							if (payTypeCode4Switch && !this.isQQEBpay) { payTypeCode4Switch = 'originQQ'; }
							switch (payTypeCode4Switch) {
								case 'WCLB':
								case 'ALB':
								case 'AP':
								case 'OA':
								case 'WC':
								case 'originQQ':
								case 'JDP':
								case 'CC':
								case 'CTC':
									return event.target.value.replace(reg, '$2$3$4');
								case 'BCM':
								case 'BC':
									// regex \.(?=.*\.) 保留一個. 其餘的.全部抓取 ||  /^0(?=\d+)/ 抓取第一個輸入的0
									return event.target.value
										.replace(/[^\d.]|\.(?=.*\.)/g, '')
										.replace(reg, '$2$3$4')
										.replace(/^0(?=\d+)/g, '');
								case 'LB':
								case 'UP':
								case 'PPB':
									return event.target.value.replace(/[^\d]+/g, '').replace(/^(0)([\d]+)/, '$2');
								default:
									return event.target.value.replace(/[^\d]+/g, '');
							}
						},
						rules: [
							{ required: true, message: '请输入金额' },
							{
								validator: (rule, value, callback) => {
									if (this.state.isSetAmountFromSuggested) {
										// all good, no error, so callback has no parameter
										return callback();
									}
									if (value) {
										this.setState({
											Amountvalue: value
										});

										if (
											payTypeCode === 'WCLB' ||
											payTypeCode === 'LB' ||
											payTypeCode === 'ALB' ||
											payTypeCode === 'AP' ||
											payTypeCode === 'BCM' ||
											payTypeCode === 'OA' ||
											payTypeCode === 'WC' ||
											// delete QQ for months. payTypeCode === 'QQ' ||
											payTypeCode === 'JDP' ||
											payTypeCode === 'CC' ||
											payTypeCode === 'PPB' ||
											payTypeCode === 'BC' ||
											(payTypeCode === 'CTC' &&
												setting.methodCode !== INVOICE_METHODCODE_OF_CTC && // <-- 3345: only allow Int
												setting.methodCode !== 'OTC' &&
												setting.methodCode !== 'INVOICE_AUT')
										) {
											!depositMoneyDecimal.test(value) && callback('金额格式错误，最高保留1至2位小数');
										} else {
											!depositMoneyInt.test(value) && callback('金额格式错误');
										}
										if (value < setting.minBal) {
											callback(`最低存款金额 ${minBal} 元`);
										}
										if (value > setting.maxBal) {
											callback(`最高存款金额 ${maxBal} 元​`);
										}
										if (payTypeCode === 'UP' || payTypeCode === 'BC' || payTypeCode === 'BCM') {
											const oddReg = /(\d*[34567]$)/;
											const isDecimal = String(value).includes('.');
											const isDecimalZero =
												isDecimal && Number(String(value).split('.')[1]) === 0;
											if (!isDecimal || isDecimalZero) {
												// 只驗證整數部分
												if (!oddReg.test(String(value).split('.')[0])) {
													callback('金额尾数必须为 3 , 4 , 5 , 6 , 7');
												}
											}
										}
										if (
											this.uniqueAmountStatus &&
											value.toString().substr(-1) === '0' &&
											payTypeCode !== 'UP' &&
											payTypeCode !== 'BC' &&
											payTypeCode !== 'BCM'
										) {
											callback('金额必须以 "1-9" 结尾');
										}
									}
									// all good, no error, so callback has no parameter
									callback();
								}
							}
						]
					})(
						<Input
							size="large"
							placeholder={`${hasMaxMoney
								? `单笔存款范围: ${minBal}~${maxBal},每日可存款${transferNumber}次`
								: `单笔存款 最低：${minBal}元起, 最高：${maxBal}元`}`}
							autoComplete="off"
							maxLength={20}
							onChange={(value) => {
								if (!this.Needlist.includes(payTypeCode)) return;
								this.Testamount(value.target.value, payTypeCode);
							}}
						/>
					)}

					{/* 新需求 推荐金额 */}
					{this.Needlist.includes(payTypeCode) &&
						this.state.SuggestedAmount != '' && (
							<div className="SuggestedAmountDiv">
								<div className="arrow" />
								{payTypeCode===ODPPayTypeCode
								? <p style={{color:'#666',display:isMoneyInSuggestionAmount(this.state.Amountvalue, this.state.SuggestedAmount) ? 'none' : ''}}>建议选择系统推荐的存款金额，以加快处理速度</p> :
								<p>请选择以下存款金额以便快速到账</p>
								}
								<ul>
									{this.state.SuggestedAmount.map((value, index) => {
										return (
											<li
												className={`${this.state.Amountvalue == value}`}
												onClick={() => {
													setFieldsValue({
														money: value
													});
													this.setState({
														...(isStillShowSuggestAmount(this.stillShowSuggestAmountForNeedlist, payTypeCode) ? {} : {SuggestedAmount:''})
														, ...{
														Amountvalue: value,
														SuggestedAmounthide: true,
														isSetAmountFromSuggested: true
														}
													});
												}}
												key={value}
											>
												{value}
											</li>
										);
									})}
								</ul>
							</div>
						)}
				</Item>
				{this.Needlist.includes(payTypeCode) && setting && setting.vendorCharges ? (
					payTypeCode==='QQ' && this.isQQEBpay ? null :
						<div className="modal-prompt-info error-color">温馨提示：此交易将征收第三方手续费，请于提交后确认交易详情，再进行转帐。</div>
				) : null}

				{payTypeCode != 'WC' &&
					this.Needlist.find((item) => item == payTypeCode) &&
					setting.charges &&
					setting.charges < 0 ? (
					<div className="TextLightYellow">
						温馨提示：使用{this.ispayMethod.name}
						进行存款时，第三方平台将征收手续费 {mul(Math.abs(setting.charges), 100)} %
					</div>
				) : null}
				<div
					className="modal-waining-info error-color"
					style={{
						display:
							setting.methodCode === 'AliBnBQR' ||
								setting.methodCode === 'WCBnBQR' ||
								this.uniqueAmountStatus
								? 'block'
								: 'none'
					}}
				>
					{/* {this.uniqueAmountStatus ? (
						'基于风控机制，建议提交充值的时候，尾数请避免输入0，建议提交1-9的金额，举例: 135元，128元等的，以免无法提交充值。'
					) : (
						'为了使您的充值快速到账，建议您输入以 “1-9” 结尾的整数金额进行充值，例如301，519元等。'
					)} */}
				</div>
				{/* <div className="modal-prompt-info">
					{hasMaxMoney ? (
						`单笔金额最低: ${minBal} 元; 最高: ${maxBal} 元 ，每日总允许金额 ${formatAmount(setting.dayBal)} 元`
					) : (
						`单笔最低金额: ${minBal} 元, 最高金额: ${maxBal} 元。`
					)}
				</div> */}
				{setting.charges !== 0 &&
					(setting.methodCode !== 'AliBnBQR' || setting.methodCode !== 'WCBnBQR') && (
						<Item label={`实际到账`} className="">
							<Input
								size="large"
								placeholder={``}
								value={charges ? charges.toFixed(2) : ''}
								disabled
								autoComplete="off"
								maxLength={20}
							/>
						</Item>
					)}
			</React.Fragment>
		);
	}
}
export default MoneyInput;
